import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=d98f2b3c&scoped=true"
import script from "./ChinaMap.vue?vue&type=script&lang=js"
export * from "./ChinaMap.vue?vue&type=script&lang=js"
import style0 from "./ChinaMap.vue?vue&type=style&index=0&id=d98f2b3c&prod&lang=scss&scoped=true"
import style1 from "./ChinaMap.vue?vue&type=style&index=1&id=d98f2b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98f2b3c",
  null
  
)

export default component.exports